import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 10px;

  p::first-letter {
    text-transform: uppercase;
  }
`;
